<template>
  <div>
      <alter-form :customeButton="true" ref="alterform" :watchImageVisible="false" :modifyData="data" @formSubmit="formSubmit" :formData="formData"></alter-form>
  </div>
</template>

<script>
// 组件
import alterForm from '@/components/alterForm'
// 接口
import apis from '@/services/index'
import jsonData from '../jsonData'

export default {
  name: 'general',
  components: {
    alterForm
  },
  props: ['data'],
  data () {
    return {
      modifyData: {},
      formData: jsonData.formData
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    async init () {
      const chargePoint = await apis.AssetApi.getChargePointSimpleList()
      this.formData[6].options = chargePoint.data.charge_points
      const tariffGroup = await apis.TariffsBillings.getTariffGroupsSimpleList()
      this.formData[7].options = tariffGroup.data.tariff_groups
    },
    formSubmit (data) {
      const obj = JSON.parse(JSON.stringify(data))
      this.$emit('tabChange', obj, 'general')
    }
  }
}
</script>

<style lang="scss" scope>
</style>
